import { useEffect } from 'react';

import { useData } from '../data/DataContext.tsx';
import { Button } from '../design/primitives.tsx';
import ui from '../design/ui.module.css';
import styles from './Shell.module.css';

// Shown instead of the app when the Worker refuses the account (suspended or
// being deleted). Nothing else loads; the person can sign out or contact us.
export function SuspendedScreen() {
  const { auth } = useData();
  useEffect(() => {
    document.title = 'Account suspended · Guildite';
  }, []);
  return (
    <main id="main" className={styles.page} style={{ maxWidth: 520, margin: '0 auto', padding: '48px 16px' }}>
      <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800 }}>Your account is suspended</h1>
      <div className={ui.stack}>
        <p className={ui.body}>You can’t use Guildite with this account right now. If you think this is a mistake, email support@guildite.com from the address you signed up with.</p>
        <p className={ui.muted}>Refunds a shop owes you are still tracked by Guildite.</p>
        <div><Button variant="secondary" onClick={() => void auth.signOut()}>Log out</Button></div>
      </div>
    </main>
  );
}
